import { EMAIL_PROBLEM, isEmailAddress } from '@app/shared'
import { useState } from 'react'
import { Field, TextInput } from '../ui'

/**
 * Who is giving: a name and an address, asked the same way whether the gift is
 * once or standing, and held by the page so the two share one answer.
 *
 * Real labels, not placeholders: a placeholder is gone the moment somebody
 * types, so the only thing naming the field disappears exactly when it is
 * being filled in. The address is not marked optional — the receipt, and for
 * a standing gift the links that confirm and stop it, go there.
 */
export function DonorFields({
  name,
  onName,
  email,
  onEmail,
  kiosk = false,
}: {
  name: string
  onName: (name: string) => void
  email: string
  onEmail: (email: string) => void
  kiosk?: boolean
}) {
  /* What is wrong with the address is said once somebody has left the field,
     rather than on the first keystroke. */
  const [left, setLeft] = useState(false)
  return (
    <>
      <Field label="Your name">
        <TextInput
          autoComplete={kiosk ? 'off' : 'name'}
          value={name}
          onChange={(e) => onName(e.target.value)}
        />
      </Field>
      <Field
        label="Email"
        problem={
          left && email.trim() && !isEmailAddress(email) ? EMAIL_PROBLEM : null
        }
      >
        <TextInput
          type="email"
          onBlur={() => setLeft(true)}
          autoComplete={kiosk ? 'off' : 'email'}
          value={email}
          onChange={(e) => onEmail(e.target.value)}
        />
      </Field>
    </>
  )
}
